import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as efficiency from "./style.module.scss";

export const Efficiency = () => {
  return (
    <section className={efficiency.efficiency} id="efficiency">
      <div className="container">
        <div className={efficiency.efficiency__wrapper}>
          <div>
            <h3 className={`${main.title_h3} ${efficiency.efficiency__title}`}>
              Почему курс <strong>«Как научить ребёнка читать быстро и с умом»</strong> эффективен и даёт результаты
            </h3>
            <div className={efficiency.efficiency__contentText}>
              <p>Это комплексная программа, рассчитанная на развитие навыков чтения у детей и расширение знаний по этой
                теме у родителей. Мы собрали методики и упражнения, которые просты в применении, но дают максимальный
                эффект даже при кратковременном использовании.</p>
              <p>Тренировка навыков чтения происходит в занимательной форме: ребёнок проделывает множество игровых
                упражнений на онлайн-платформе, читая книгу-пособие, вовлекается в приключенческую историю, в помощь
                героям выполняет развивающие задания.</p>
            </div>
          </div>
          <div>
            <div className={efficiency.efficiency__videoWrapper}>
              <iframe
                className={efficiency.video__media}
                src="https://www.youtube.com/embed/RZUj4i3AfP4"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className={efficiency.efficiency__videoText}><p>Отзывы детей 8–12 лет </p></div>
            <div className={efficiency.efficiency__videoWrapper}>
              <iframe
                className={efficiency.video__media} src="https://www.youtube.com/embed/kPx5845akdE"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className={efficiency.efficiency__videoText}><p>Отзыв Инны и Марка Толстовых</p></div>
          </div>
        </div>
      </div>
    </section>
  );
};
